export const formatMoney = (number, showMoney = false, options = {}) => {
    const { decimals = 2, rounded = false } = options
    showMoney = showMoney ? "MXN" : ""
    if (typeof number !== 'number') return `$0.00 ${showMoney}`
    return rounded ?
        `$${Math.ceil(Number(number)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.00 ${showMoney}`
        : `$${Number(number).toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${showMoney}`
}